export default "__VITE_ASSET__DRXxOlqX__"